import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { IconImgUpload2 } from "../../../../../icons/IconImgUpload2";
import { StepperInglesLargo } from "../../../../../components/StepperInglesLargo";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

import "./style.css";

export const CorporativoBusinessBankingDocumentsWeb = () => {
  const colors = useDynamicColors();

  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-checkout-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-documentos">
            <div className="div-2">
              <div className="overlap-2">
                <div className="group-wrapper">
                  <div className="group-2">
                    <div className="overlap-3">
                      <div className="frame-2">
                        <div className="div-wrapper-sp">
                          <div className="group-3">
                            <div className="frame-wrapper">
                              <div className="frame-3">
                                <div className="text-wrapper-2">
                                  Attach documents
                                </div>

                                <p className="subtitle">
                                  <strong>
                                    Upload documents or photos from your device.
                                  </strong>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="frame-4" />
                      </div>

                      <div className="document-upload">
                        <div className="section-documento  ">
                          {[
                            "Legal document(s) establishing your business",
                            "Doing Business As (DBA) Certificate",
                            "Business License",
                            "Power of Attorney",
                          ].map((item, idx) => (
                            <div key={idx} className="other-item">
                              <h3>• {item}</h3>
                              <IconImgUpload2
                                className="icon-img-upload-3"
                                color="#0F316D"
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="frame-5">
                        <div className="frame-4" />
                      </div>
                    </div>

                    <div className="frame-6">
                      <div className="text-3">Continue later</div>
                      <div onClick={handleButtonClick}>
                        <ButtonLargeWeb
                          className="button-large-WEB-instance"
                          iconLeft={false}
                          iconRigth={false}
                          primarioActive
                          primarioInactive={false}
                          secundarioActive={false}
                          secundarioInactive={false}
                          terciarioActive={false}
                          terciarioInactive={false}
                          text="Continue"
                          textClassName="button-large-WEB-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="group-30">
                <div className="frame-7">
                  © 2025 All rights reserved
                  <img width={100} height="auto" src="/img/veritran.svg" />
                  Innovation Lab
                </div>
              </div>

              <div className="frame-8">
                <div className="frame-9">
                  <div className="text-wrapper-12">
                    Account opening application
                  </div>
                </div>

                <div className="group-31">
                  <div className="group-32">
                    <div className="group-33">
                      <div className="stepper-ingles-largo-wrapper">
                        <StepperInglesLargo
                          className="stepper-ingles-largo-instance"
                          componentsStepsClassName="stepper-ingles-largo-2"
                          componentsStepsClassNameOverride="stepper-ingles-largo-2"
                          numberWrapperClassName="stepper-ingles-largo-2"
                          prendidoHasta={8}
                          prendido="three"
                          property2="three"
                          vector="/img/vector-41-1.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-7">
                {colors.url_logo !== "" && (
                  <img width={30} height="auto" src={colors.url_logo} />
                )}
                <div className="language">
                  <img
                    src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                    height={30}
                    width={30}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
